import { Component } from 'react'

import ComponentRegistry from './ComponentRegistry'
import { SpacingPropTypes } from './PropTypes'
import withSpacing from './WithSpacing'

interface ContainerWithoutSpacingProps {
  actionHandler?(...args: unknown[]): unknown
  cardId: string
  items: unknown[]
  preserveFirstChildSpacing?: boolean
  registerInputCallback(...args: unknown[]): unknown
  separator?: boolean
  spacing?: SpacingPropTypes
}

export class ContainerWithoutSpacing extends Component<ContainerWithoutSpacingProps> {
  static displayName = 'Container'

  renderChildren() {
    const { items, actionHandler, registerInputCallback, cardId, preserveFirstChildSpacing } = this.props

    return items.map((cardElement: any, index: any) => {
      const CardElement = ComponentRegistry.getComponent(cardElement.type)
      if (CardElement) {
        return (
          // @ts-expect-error
          <CardElement
            key={index}
            cardId={cardId}
            {...cardElement}
            spacing={preserveFirstChildSpacing ? cardElement.spacing : index === 0 ? 'none' : cardElement.spacing}
            separator={preserveFirstChildSpacing ? cardElement.separator : index === 0 ? false : cardElement.separator}
            actionHandler={actionHandler}
            registerInputCallback={registerInputCallback}
          />
        )
      } else {
        return <div key={index} />
      }
    })
  }

  render() {
    return <div data-id="wg-container">{this.renderChildren()}</div>
  }
}

// Wrapping this in "withSpacing" seems to break because of the others that extend on it actually do this
export default withSpacing(ContainerWithoutSpacing)
